/**
 * @fileoverview Client components exports for the RAG chatbot system
 * @module client
 *
 * This module provides customer-facing components and hooks for integrating
 * the RAG chatbot into client applications and websites.
 */

// Component exports
export { ChatDock } from "./components/chat-dock";
export { ChatbotDemo } from "./components/chatbot-demo";
export { ChatbotWidget } from "./components/chatbot-widget";
export { FloatingChatButton } from "./components/floating-chat-button";
export { SuggestedQuestions } from "./components/suggested-questions";

// Context & Configuration exports
export { I18nProvider, useI18n } from "./components/i18n-context";

// Configuration exports (types and constants)
export type {
  ChatbotTranslations,
  SupportedLanguage,
  LanguageInfo,
} from "./components/i18n-config";
export {
  translations,
  languages,
  detectBrowserLanguage,
  t,
  isRTL,
  adjustTextLength,
} from "./components/i18n-config";

export type {
  SuggestedQuestion,
  QuestionCategory,
} from "./components/suggested-questions-config";
export {
  DEFAULT_QUESTIONS,
  QUESTION_CATEGORIES,
  CONTEXTUAL_QUESTIONS,
  QuestionAnalytics,
} from "./components/suggested-questions-config";

export type { ChatbotTheme, ThemeName } from "./components/theme-config";
export {
  defaultTheme,
  darkTheme,
  compactTheme,
  themes,
  getThemeVariables,
  applyTheme,
  createThemeStylesheet,
  generateThemeClasses,
  useTheme,
} from "./components/theme-config";
